package ru.malygin.urls.url

class GetAllDataFromDatabase {
    val urlHead = "/getAllDataFromDatabase"
}